import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=f43d1d04&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=ts&"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=f43d1d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43d1d04",
  null
  
)

export default component.exports